import React, { useState } from 'react';
import config from '../config';

/** An ingredient's product photo, or its emoji when there is no photo or it fails to load. */
const IngredientPhoto = ({ imageUrl, emoji, className = '' }) => {
    const [broken, setBroken] = useState(false);
    return (
        <span className={className}>
            {imageUrl && !broken
                ? <img src={`${config.apiUrl.replace(/\/$/, '')}/${imageUrl}`} alt="" loading="lazy" onError={() => setBroken(true)} />
                : emoji}
        </span>
    );
};

export default IngredientPhoto;
